import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  EnodeVehicle,
  SmartChargingStatus
} from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-status-icon',
  templateUrl: './status-icon.component.html',
  styleUrls: ['./status-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusIconComponent {
  @Input() vehicle: EnodeVehicle;
  @Input() smartStatus: SmartChargingStatus;

  selectedIcon: 'charging' | 'unplugged' | 'paused' | 'unreachable' | 'loading';

  constructor() {}

  ngOnInit() {
    if (!this.vehicle.chargeState.isPluggedIn) {
      this.selectedIcon = 'unplugged';
    } else if (
      (this.vehicle.chargeState.isPluggedIn &&
        this.vehicle.chargeState.isCharging) ||
      (this.vehicle.chargeState.isPluggedIn &&
        this.vehicle.chargeState.isCharging &&
        this.vehicle.chargeState.isFullyCharged)
    ) {
      this.selectedIcon = 'charging';
    } else if (
      this.smartStatus?.state === 'PLAN:EXECUTING:STOPPING' ||
      this.smartStatus?.state === 'PLAN:EXECUTING:STARTING'
    ) {
      this.selectedIcon = 'loading';
    } else if (
      (this.vehicle.chargeState.isPluggedIn &&
        !this.vehicle.chargeState.isCharging) ||
      this.smartStatus?.state === 'PLAN:EXECUTING:STOPPED' ||
      this.smartStatus?.state === 'PLAN:EXECUTING:STOPPED:AWAITING_PRICES'
    ) {
      this.selectedIcon = 'paused';
    } else if (!this.vehicle.isReachable) {
      this.selectedIcon = 'unreachable';
    } else {
      this.selectedIcon = undefined;
    }
  }
}
